import {
  Card,
  CardContent,
  Checkbox,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import NumberFormat from "react-number-format";

const personsNum = [...Array(9).keys()].slice(1);

const LimitInputs: React.FC<{ title: string; alias: string }> = ({
  title,
  alias,
}) => {
  const [enabled, setEnabled] = useState(false);
  const toggleEnabled = () => setEnabled(!enabled);
  return (
    <Grid item xs={12} xl={6}>
      <Card>
        <CardContent>
          <Typography variant="h6">
            <Checkbox checked={enabled} onClick={toggleEnabled} />
            {title}
          </Typography>
          <TableContainer>
            <Table style={{ minWidth: 0 }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="30%">Bedroom Size</TableCell>
                  <TableCell>Rent per month</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key="studio">
                  <TableCell>Studio</TableCell>
                  <TableCell>
                    <NumberFormat
                      disabled={!enabled}
                      fullWidth
                      allowNegative={false}
                      variant="outlined"
                      margin="dense"
                      label="Rent"
                      name="rent"
                      customInput={TextField}
                      prefix="$"
                      type="text"
                      thousandSeparator
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">/mo</InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                </TableRow>
                {personsNum
                  .map((number) => {
                    const label =
                      number === 1 ? "1 Bedroom" : `${number} Bedrooms`;
                    return { key: `${alias}.n${number}`, label };
                  })
                  .map(({ key, label }) => (
                    <TableRow key={key}>
                      <TableCell>{label}</TableCell>
                      <TableCell>
                        <NumberFormat
                          disabled={!enabled}
                          fullWidth
                          allowNegative={false}
                          variant="outlined"
                          margin="dense"
                          label="Rent"
                          name="rent"
                          customInput={TextField}
                          prefix="$"
                          type="text"
                          thousandSeparator
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                /mo
                              </InputAdornment>
                            ),
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default LimitInputs;
